import { Box, Paper, Stack, TextField, Typography } from '@mui/material';
import { formatearFechaLarga } from '../../../utils/horaLocal';

export default function HeaderDia({ fecha, onChange }) {
  return (
    <Paper sx={{ p: 3, mb: 4, bgcolor: '#f5f5f5' }}>
      <Stack spacing={2}>
        <Box display="flex" alignItems="center" gap={2}>
          <Typography variant="h6">📅 Configurar Día:</Typography>
          <TextField
            type="date"
            value={fecha}
            onChange={(e) => onChange(e.target.value)}
            sx={{ width: 200 }}
          />
          <Typography variant="body1" sx={{ ml: 2 }}>
            {formatearFechaLarga(fecha)}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
}
